import { render, staticRenderFns } from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=template&id=f946460c&"
import script from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports